module.exports = __webpack_public_path__ + "static/media/banner_record_bg.2d323bff.png";